export default "__VITE_ASSET__orNi7fty__"